import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

function SubscriptionStatus() {
  const { subscription } = useAuth();

  if (!subscription) {
    return (
      <div className="subscription-banner subscription-free">
        <span>📢 پلن رایگان - برای دسترسی به امکانات کامل، اشتراک خود را ارتقا دهید</span>
        <a href="/plans" className="subscription-upgrade-link">مشاهده پلن‌ها</a>
      </div>
    );
  }

  const planName = subscription.plan?.name || 'رایگان';

  if (subscription.status === 'trial') {
    return (
      <div className="subscription-banner subscription-trial">
        <span>🔹 دوره آزمایشی - {planName}</span>
      </div>
    );
  }

  return (
    <div className="subscription-banner subscription-active">
      <span>✅ پلن فعال: {planName}</span>
    </div>
  );
}

export default SubscriptionStatus;